export const NEW_OBJECT_TEMPLATE = {
  objectName: '',
  idFields: '',
  additionalFields: '',
  displayColumns: '',
};
